import { render, staticRenderFns } from "./OurInfo.vue?vue&type=template&id=48c5e3bd&scoped=true&"
import script from "./OurInfo.vue?vue&type=script&lang=js&"
export * from "./OurInfo.vue?vue&type=script&lang=js&"
import style0 from "./OurInfo.vue?vue&type=style&index=0&id=48c5e3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c5e3bd",
  null
  
)

export default component.exports